import { render, staticRenderFns } from "./orderFlb.vue?vue&type=template&id=727fd719&scoped=true"
import script from "./orderFlb.vue?vue&type=script&lang=js"
export * from "./orderFlb.vue?vue&type=script&lang=js"
import style0 from "./orderFlb.vue?vue&type=style&index=0&id=727fd719&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727fd719",
  null
  
)

export default component.exports